import DeleteAccount from "@/components/DeleteAccount";

const DeleteAccountPage = () => {
  return <DeleteAccount />;
};

export default DeleteAccountPage;
